import { forwardRef } from 'react';
import { Icon } from '@iconify/react';
import { Box } from '@mui/material';

interface IconifyProps {
  icon: string | any;
  size?: number | string;
  sx?: any;
  onClick?: () => void;
}

const Iconify = forwardRef(
  ({ icon, size = 20, sx, onClick, ...other }: IconifyProps, ref) => (
    <Box
      ref={ref}
      component={Icon}
      icon={icon}
      sx={{ width: size, height: size, ...sx }}
      onClick={onClick}
      {...other}
    />
  )
);

export default Iconify;
